<template>
  <h1>Client Users (to be developed)</h1>
</template>

<script>
export default {
  name: "ClientUsers"
};
</script>
